/*
 * @Descripttion:
 * @version:
 * @Author: 孙鑫鑫
 * @Date: 2022-02-10 09:08:00
 * @LastEditors: 孙鑫鑫
 * @LastEditTime: 2022-04-28 09:23:46
 */
import HeaderAsideLayout from "@/layouts/HeaderAsideLayout";
import material from "./appPages/material";
import draft from "./appPages/draft";
import opinion from "./appPages/opinion";
const list = [
  {
    path: "/index",
    component: HeaderAsideLayout,
    children: [
      { path: "/index", component: () => import("@/pages/index/index.vue") },
      ...material,
      ...draft,
      ...opinion,
      //通知
      {
        path: "/notice",
        component: () => import("@/pages/notice/index.vue"),
      },
      // 用户中心
      {
        path: "/user",
        component: () => import("@/pages/userCenter/index.vue"),
      },
      // 用户中心
      {
        path: "/password",
        name: "password",
        component: () => import("@/pages/userCenter/EditPassword.vue"),
      },
    ],
  },
];
export default list;
